import {
  createDocument,
  getAllData,
  getAllDataWithoutToast,
  updateDocumentByID,
} from "apis/customApiHandler";
import { Fragment, useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Button, Input, Select } from "styled";
import { TD, TH } from "styled/table";
import { BiCloudDownload } from "react-icons/bi";
import axios from "apis/axios";
import ReactSelect from "react-select";
import { filterSelectStyles } from "utils/reactSelectStyles";
import Spinner from "components/Spinner";
import exportExcel from "utils/exportExcel";
import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";
import getFormattedDate from "utils/helpers";
import Modal from "components/Modal";
import { useFormik, Form, FormikProvider } from "formik";
import InputField from "components/formik/InputField";
import { useQuery, useQueryClient } from "react-query";
import toast from "react-hot-toast";

import { FaEdit, FaEye, FaTrash } from "react-icons/fa";
import checkPermission from "utils/checkPermission";
import { permissions } from "../utils/permissionConstants";

const contractTypeOptions = [
  { value: "All", label: "All" },
  { value: "CPKM", label: "CPKM" },
  { value: "NON CPKM", label: "NON CPKM" },
];

const inspectionTypeOptions = [
  { value: "All", label: "All" },
  { value: "manual", label: "Manual" },
  { value: "dgauge", label: "DGauge" },
];

const InspectionReport = () => {
  const ids = window.location.search.split("=")[1];
  const [selectedFleets, setSelectedFleets] = useState([]);
  const [selectedHubs, setSelectedHubs] = useState([]);
  const [fleetMap, setFleetMap] = useState({});
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [page, setPage] = useState(1);
  const [kmFrom, setKmFrom] = useState("");
  const [kmTo, setKmTo] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [contractType, setContractType] = useState("All");
  const [inspectionType, setInspectionType] = useState("All");
  const [alignment, setAlignment] = useState("All");
  const [rotation, setRotation] = useState("All");
  const [replacement, setReplacement] = useState("All");
  const [selectedInspectedBy, setSelectedInspectedBy] = useState([]);
  const [reportData, setReportData] = useState("");
  const [downloading, setDownloading] = useState(false);
  const [downloadingDump, setDownloadingDump] = useState(false);
  const [enabled, setEnabled] = useState(false);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const currentUser = useSelector(state=> state.user.currentUser)
  const limit = 20;

  const getData = async (pg) => {
    setIsLoading(true);
    const dt = await createDocument("/inspection/dashboard", {
      ...(selectedFleets?.includes("all")
        ? {
            fleets: getFleetOptions()
              .filter((item) => item.value !== "all" && item.value !== "clear")
              .map((item) => item.value)
              .join(","),
          }
        : selectedFleets.length && {
            fleets: selectedFleets.map((fleet) => fleet).join(","),
          }),
      ...(selectedHubs?.includes("all")
        ? {
            hubs: getHubOptions()
              .filter((item) => item.value !== "all" && item.value !== "clear")
              .map((item) => item.value)
              .join(","),
          }
        : selectedHubs.length && {
            hubs: selectedHubs.map((hub) => hub).join(","),
          }),
      ...(ids && {
        ids,
      }),
      ...(searchQuery && { searchQuery }),
      ...(contractType !== "All" && contractType !== "" && { contractType }),
      ...(inspectionType !== "All" && inspectionType !== "" && { inspectionType }),
      ...(selectedInspectedBy.length && {
        inspectedBy: selectedInspectedBy.join(","),
      }),
      dateFrom,
      dateTo: dateFrom && dateTo ? dateTo : new Date().toISOString().split("T")[0],
      kmFrom,
      kmTo,
      wheelAlignment: alignment,
      tyreReplacement: replacement,
      tyreRotation: rotation,
      page: pg ? pg : page,
      download: 0,
      limit: limit,
    });
    // console.log(dt)
    setData(dt);
    setIsLoading(false);
  };

  useEffect(() => {
    if (
      (selectedFleets.length === 0 || selectedHubs.length === 0) &&
      !searchQuery
    ) {
      // console.log("");
    } else getData(page);
  }, [page]);

  const { data: allFleets } = useQuery([`/customer-fleet`], () =>
    getAllData("/customer-fleet", {
      limit: 3000,
    })
  );
  const { data: allHubs } = useQuery([`/customer-hub`], () =>
    getAllData("/customer-hub", {
      limit: 3000,
    })
  );
  const { data: inspectedByUsers, isLoading: inspectedByLoading } = useQuery(
    [
      "/inspection/inspected-by-users",
      selectedFleets,
      selectedHubs,
      allFleets?.data,
      allHubs?.data,
    ],
    () =>
      createDocument("/inspection/inspected-by-users", {
        ...(selectedFleets?.includes("all")
          ? {
              fleets: getFleetOptions()
                ?.filter((item) => item.value !== "all" && item.value !== "clear")
                ?.map((item) => item.value)
                ?.join(","),
            }
          : selectedFleets?.length && {
              fleets: selectedFleets.map((f) => f).join(","),
            }),
        ...(selectedHubs?.includes("all")
          ? {
              hubs: getHubOptions()
                ?.filter((item) => item.value !== "all" && item.value !== "clear")
                ?.map((item) => item.value)
                ?.join(","),
            }
          : selectedHubs?.length && {
              hubs: selectedHubs.map((h) => h).join(","),
            }),
      }),
    {
      enabled: selectedFleets.length > 0 && selectedHubs.length > 0,
      retry: false,
    }
  );

  const getDownloadData = async () => {
    setDownloading(true);
    try {
      const dt = await createDocument("/inspection/dashboard/download", {
        ...(selectedFleets?.includes("all")
          ? {
              fleets: getFleetOptions()
                .filter(
                  (item) => item.value !== "all" && item.value !== "clear"
                )
                .map((item) => item.value)
                .join(","),
            }
          : selectedFleets.length && {
              fleets: selectedFleets.map((fleet) => fleet).join(","),
            }),
        ...(selectedHubs?.includes("all")
          ? {
              hubs: getHubOptions()
                .filter(
                  (item) => item.value !== "all" && item.value !== "clear"
                )
                .map((item) => item.value)
                .join(","),
            }
          : selectedHubs.length && {
              hubs: selectedHubs.map((hub) => hub).join(","),
            }),
        ...(ids && {
          ids,
        }),
        ...(searchQuery && { searchQuery }),
        ...(contractType !== "All" && contractType !== "" && { contractType }),
        ...(inspectionType !== "All" && inspectionType !== "" && { inspectionType }),
        ...(selectedInspectedBy.length && {
          inspectedBy: selectedInspectedBy.join(","),
        }),
        dateFrom,
        dateTo,
        kmFrom,
        kmTo,
        wheelAlignment: alignment,
        tyreReplacement: replacement,
        tyreRotation: rotation,
        download: 1,
      });
      // console.log(dt)
      if (dt?.data) setReportData(dt.data);
      toast.success( dt?.message || "Report Shared on email successfully");
      setDownloading(false);
    } catch {
      setDownloading(false);
    }
  };

  const generateEmail = async () => {
    setDownloadingDump(true);
    try {
      const token = localStorage.getItem("token");
      const myPromise = axios({
        method: "post",
        url: `${process.env.REACT_APP_API_URL}inspection/getQuarterInspections/download`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: {
          ...(selectedHubs?.includes("all")
            ? {
                hubs: getHubOptions()
                  .filter(
                    (item) => item.value !== "all" && item.value !== "clear"
                  )
                  .map((item) => item.value)
                  .join(","),
              }
            : selectedHubs.length && {
                hubs: selectedHubs.map((hub) => hub).join(","),
              }),

          ...(selectedFleets?.includes("all")
            ? {
                fleets: getFleetOptions()
                  .filter(
                    (item) => item.value !== "all" && item.value !== "clear"
                  )
                  .map((item) => item.value)
                  .join(","),
              }
            : selectedFleets.length
            ? { fleets: selectedFleets.join(",") }
            : {}),
          contractType,
          dateFrom,
          dateTo,
          searchQuery,
          ...(selectedInspectedBy.length && {
            inspectedBy: selectedInspectedBy.join(","),
          }),
          reportName: "Vehicle Fleet Report",
        },
      });

      await toast.promise(
        myPromise,
        {
          loading: "Request Initiated, Please Hold on",
          success: (dt) => dt.data.message || "success",
          error: (err) =>
            err?.response?.data?.error ||
            err?.response?.data?.message ||
            err?.message ||
            "Something went wrong",
        },
        {
          success: {
            duration: 3000,
            icon: "📩",
          },
        }
      );
    } catch (err) {
      console.error("Error downloading report:", err);
    } finally {
      setDownloadingDump(false);
    }
  };

  const getFleetOptions = useCallback(() => {
    if (allFleets && allFleets.data && allFleets.data.length) {
      return [
        {
          label: "All",
          value: "all",
        },
        {
          label: "Clear",
          value: "clear",
        },
        ...allFleets?.data?.map((fleet) => {
          return {
            value: fleet._id,
            label: fleet.fleetName,
          };
        }),
      ];
    }
  }, [allFleets]);

  const getHubOptions = useCallback(() => {
    if (allHubs && allHubs.data && allHubs.data.length) {
      return [
        ...(selectedFleets?.length
          ? [
              {
                label: "All",
                value: "all",
              },
            ]
          : []),
        ...(selectedFleets?.length
          ? [
              {
                label: "Clear",
                value: "clear",
              },
            ]
          : []),
        ...(selectedFleets?.includes("all")
          ? allHubs?.data?.length &&
            allHubs?.data?.map((hub) => {
              // console.log(hub)
              return {
                value: hub._id,
                label: hub.hubName,
              };
            })
          : allHubs?.data?.length &&
            allHubs?.data
              ?.filter((hub) => {
                // console.log(hub)
                const selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                  selectedFleets?.includes(fleet._id)
                );

                return selectedFleetsVal?.some(
                  (fleet) => fleet.fleetCode === hub.fleetCode
                );
              })
              ?.map((hub) => {
                return {
                  value: hub._id,
                  label: hub.hubName,
                };
              })),
      ];
    }
  }, [allFleets, allHubs, selectedFleets]);

  const getInspectedByOptions = useCallback(() => {
    // Only use users who have actually inspected vehicles
    const usersToUse = inspectedByUsers?.data || [];
    
    if (usersToUse.length) {
      return usersToUse.map((user) => {
        return {
          value: user._id,
          label: user.name,
        };
      });
    }
    return [];
  }, [inspectedByUsers]);

  console.log(getHubOptions());
  return (
    <div>
      <div className="w-full flex flex-col text-gray-500">
        <div className="w-full px-8 flex justify-center items-end gap-4">
          <label className="w-full py-3 flex flex-col gap-2">
            Select Fleets
            <ReactSelect
              styles={filterSelectStyles}
              className="shadow-md rounded-md"
              options={getFleetOptions()}
              value={
                selectedFleets &&
                selectedFleets?.map((fleet) => {
                  return {
                    value: fleet,
                    label: getFleetOptions()?.find(
                      (item) => item?.value === fleet
                    )?.label,
                  };
                })
              }
              onChange={(value) => {
                let allValues = value?.map((item) => item.value);
                if (allValues?.includes("clear")) {
                  // console.log(allValues)
                  setSelectedFleets([]);
                  setSelectedHubs([]);
                  return;
                }
                if (
                  !selectedFleets?.includes("all") &&
                  allValues.includes("all")
                ) {
                  setSelectedFleets(["all"]);
                  return;
                }

                if (selectedFleets.includes("all")) {
                  // console.log("first");
                  // console.log(getFleetOptions())
                  value = value.filter((item) => item.value !== "all");
                }

                let selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                  value?.map((item) => item.value)?.includes(fleet._id)
                );

                let selectedHubsVal = allHubs?.data?.filter((hub) =>
                  selectedHubs?.map((item) => item)?.includes(hub._id)
                );

                setSelectedHubs(
                  selectedHubsVal
                    ?.filter((hub) =>
                      selectedFleetsVal?.find(
                        (fleet) => fleet.fleetCode === hub.fleetCode
                      )
                    )
                    .map((hub) => hub._id)
                );

                // console.log({allHubs, selectedHubs})

                setSelectedFleets(value.map((fleet) => fleet.value));
              }}
              name="fleets"
              isMulti={true}
            />
          </label>
          <label className="w-full py-3 flex flex-col gap-2">
            Select Hubs
            <ReactSelect
              styles={filterSelectStyles}
              className="shadow-md rounded-md"
              options={getHubOptions()}
              value={
                selectedHubs &&
                selectedHubs?.map((hub) => {
                  // console.log({hub})
                  return {
                    value: hub,
                    label: getHubOptions()?.find((item) => item.value === hub)
                      ?.label,
                  };
                })
              }
              onChange={(value) => {
                const allValues = value?.map((item) => item.value);
                // console.log({allValues})
                if (allValues?.includes("clear")) {
                  setSelectedHubs([]);
                  return;
                }
                if (
                  !selectedHubs?.includes("all") &&
                  allValues.includes("all")
                ) {
                  let selectedFleetCodes = allFleets?.data
                    ?.filter((fleet) => selectedFleets?.includes(fleet._id))
                    ?.map((fleet) => fleet.fleetCode);

                  const selectedHubsData = allHubs?.data?.filter((hub) =>
                    selectedFleetCodes?.includes(hub.fleetCode)
                  );

                  const mp = fleetMap;
                  selectedHubsData.map((hub) => {
                    if (selectedFleetCodes?.includes(hub.fleetCode)) {
                      if (mp[hub.fleetCode] === undefined)
                        mp[hub.fleetCode] = [];
                      mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id];
                    }
                  });

                  setFleetMap(mp);
                  setSelectedHubs(["all"]);
                } else {
                  // console.log({value})
                  value = value.filter((value) => value.value !== "all");
                  // console.log({value})
                  let selectedFleetCodes = allFleets?.data
                    ?.filter((fleet) => selectedFleets?.includes(fleet._id))
                    ?.map((fleet) => fleet.fleetCode);
                  // console.log({allValues})

                  const selectedHubsData = allHubs?.data?.filter((hub) =>
                    allValues?.includes(hub._id)
                  );
                  const mp = {};
                  selectedHubsData.map((hub) => {
                    mp[hub.fleetCode] = [];
                  });

                  selectedHubsData.map((hub) => {
                    if (selectedFleetCodes?.includes(hub.fleetCode)) {
                      if (mp[hub.fleetCode] === undefined)
                        mp[hub.fleetCode] = [];
                      mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id];
                    }
                  });

                  setFleetMap(mp);
                  setSelectedHubs(value.map((hub) => hub.value));
                }
              }}
              name="hubs"
              isMulti={true}
            />
          </label>
        </div>
        <div className="w-full px-8 flex flex-row flex-wrap lg:flex-nowrap justify-start items-end gap-4">
          <label className="w-full py-3 flex flex-col gap-2">
            Start Date{" "}
            <Input
              type="date"
              max={getFormattedDate()}
              name="dateFrom"
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
            />
          </label>
          <label className="w-full py-3 flex flex-col gap-2">
            End Date{" "}
            <Input
              type="date"
              min={getFormattedDate(dateFrom)}
              name="dateTo"
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
            />
          </label>
          <label className="w-full py-3 flex flex-col gap-2">
            KM From{" "}
            <Input
              type="number"
              value={kmFrom}
              onChange={(e) => setKmFrom(e.target.value)}
            />
          </label>
          <label className="w-full py-3 flex flex-col gap-2">
            KM To{" "}
            <Input
              type="number"
              value={kmTo}
              onChange={(e) => setKmTo(e.target.value)}
            />
          </label>
          <label className="w-full py-3 flex flex-col gap-2">
            Contract Type
            <ReactSelect
              styles={filterSelectStyles}
              name="contractType"
              className="shadow-md rounded-md"
              value={contractTypeOptions.find(
                (option) => option.value === contractType
              )} 
              onChange={(option) => {
                setContractType(option.value);
              }}
              options={contractTypeOptions}
            />
          </label>
          <label className="w-full py-3 flex flex-col gap-2">
            Inspection Type
            <ReactSelect
              styles={{
                ...filterSelectStyles,
                control: (base, state) => ({
                  ...filterSelectStyles.control(base, state),
                  borderColor:
                    state.isFocused || state.menuIsOpen
                      ? "rgb(34 197 94)"
                      : "transparent",
                  borderWidth:
                    state.isFocused || state.menuIsOpen ? "2px" : "1px",
                }),
              }}
              name="inspectionType"
              className="shadow-md rounded-md"
              value={inspectionTypeOptions.find(
                (option) => option.value === inspectionType
              )} 
              onChange={(option) => {
                setInspectionType(option.value);
              }}
              options={inspectionTypeOptions}
            />
          </label>
          <label className="w-full py-3 flex flex-col gap-2">
            Inspected By
            <ReactSelect
              styles={{
                ...filterSelectStyles,
                control: (base, state) => ({
                  ...filterSelectStyles.control(base, state),
                  borderColor:
                    state.isFocused || state.menuIsOpen
                      ? "rgb(34 197 94)"
                      : "transparent",
                  borderWidth:
                    state.isFocused || state.menuIsOpen ? "2px" : "1px",
                }),
              }}
              name="inspectedBy"
              className="shadow-md rounded-md"
              placeholder={
                inspectedByLoading
                  ? "Loading users..."
                  : selectedFleets.length === 0 || selectedHubs.length === 0
                  ? "select"
                  : "select"
              }
              isLoading={inspectedByLoading}
              isDisabled={
                inspectedByLoading ||
                selectedFleets.length === 0 ||
                selectedHubs.length === 0
              }
              isMulti
              options={getInspectedByOptions()}
              value={selectedInspectedBy.map((id) => {
                const opt = getInspectedByOptions().find((o) => o.value === id);
                return opt ? { value: opt.value, label: opt.label } : null;
              }).filter(Boolean)}
              onChange={(options) => {
                setSelectedInspectedBy(options?.map((o) => o.value) || []);
              }}
            />
          </label>
        </div>
        <div className="w-full px-8 grid grid-cols-3 lg:grid-cols-6 justify-start items-end gap-x-4">
          <label className="w-full py-3 flex flex-col gap-2">
            Vehicle Number
            <Input
              type="text"
              name="searchQuery"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </label>

          <div className="flex flex-row col-span-2 items-end gap-x-2">
            <label className="w-full py-3 flex flex-col gap-2">
              Alignment
              <Select
                name="alignment"
                value={alignment}
                onChange={(e) => setAlignment(e.target.value)}
              >
                <option value="All ">All</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </Select>
            </label>
            <label className="w-full py-3 flex flex-col gap-2">
              Rotation
              <Select
                name="rotation"
                value={rotation}
                onChange={(e) => setRotation(e.target.value)}
              >
                <option value="All ">All</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </Select>
            </label>
            <label className="w-full py-3 flex flex-col gap-2">
              Replacement
              <Select
                name="replacement"
                value={replacement}
                onChange={(e) => setReplacement(e.target.value)}
              >
                <option value="All ">All</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </Select>
            </label>
          </div>
          <div className="flex flex-row flex-wrap gap-3 flex-1 col-span-2 w-full items-end justify-start mb-3">
            <Button
              type="button"
              bgPrimary
              onClick={() => {
                setPage(1);
                getData();
              }}
              disabled={
                (selectedFleets.length === 0 || selectedHubs.length === 0) &&
                !searchQuery
              }
            >
              Search
            </Button>
            {(selectedHubs.length !== 0 || searchQuery) && checkPermission([permissions.download_inspection_dump], currentUser) && <Button
              type="button"

              disabled={(selectedFleets.length === 0 || !dateFrom || !dateTo) && !searchQuery}

              bgPrimary
              onClick={() => generateEmail()}
            >
              Inspection Dump
            </Button>}
            {downloading
              ? "Downloading..."
              : (selectedHubs.length !== 0 || searchQuery) && (
                  <BiCloudDownload
                    className="w-10 h-10 text-green-500 hover:scale-105 cursor-pointer text-center"
                    onClick={async () => {
                      await getDownloadData();
                    }}
                  />
                )}
          </div>
        </div>
      </div>

      {isLoading ? (
        <Spinner />
      ) : (
        <>
          {data && (
            <div className="flex flex-col m-2 lg:m-10">
              <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                  <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50">
                        <tr>
                          <TH scope="col">S.N.</TH>
                          <TH scope="col">Inspection Date</TH>
                          <TH scope="col">Vehicle Number</TH>
                          <TH scope="col">Inspected Hub</TH>
                          <TH scope="col">Inspected By</TH>
                          <TH scope="col">Contract Type</TH>
                          <TH scope="col">Kilometer Travelled</TH>
                          <TH scope="col">Odometer Reading</TH>
                          <TH scope="col">Wheel Alignment</TH>
                          <TH scope="col">Wheel Alignment Report</TH>
                          <TH scope="col">Tyre Rotation</TH>
                          <TH scope="col">Tyre Replacement</TH>
                          <TH scope="col">Inspection Type</TH>
                          <TH scope="col">Download</TH>
                          <TH scope="col">Action</TH>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {data &&
                          data.data?.map((d, idx) => (
                            <ViewList
                              page={page}
                              data={d}
                              idx={idx}
                              getData={getData}
                              prevInspection={
                                idx != limit - 1 ? data.data[idx + 1] : null
                              }
                            />
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {data && data.pageInfo && data.pageInfo.total && (
                <div className="container mx-auto flex justify-center items-center gap-2 py-5">
                  <Button
                    onClick={() => {
                      setPage((p) => Math.max(p - 1, 1));
                    }}
                    disabled={page === 1}
                    className="disabled:pointer-events-none disabled:opacity-70 px-0 "
                    primary
                  >
                    <div className="flex gap-1 items-center">
                      <IoMdArrowBack />
                      Prev Page
                    </div>
                  </Button>
                  <span className="text-gray-600 px-4">{`showing: ${
                    (page - 1) * 20 + 1
                  } - ${Math.min(data?.pageInfo?.total, page * 20)} of ${
                    data.pageInfo.total
                  }`}</span>

                  {data.pageInfo.total > page * 20 && (
                    <Button
                      onClick={() => {
                        setPage((p) => Math.min(p + 1, data?.pageInfo?.total));
                      }}
                      disabled={page === data?.pageInfo?.total}
                      className="disabled:pointer-events-none disabled:opacity-70 px-0 "
                      primary
                    >
                      <div className="flex gap-1 items-center">
                        Next Page
                        <IoMdArrowForward />
                      </div>
                    </Button>
                  )}
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default InspectionReport;

const ViewList = ({ data, page, idx, getData, prevInspection }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [showEditModel, setShowEditModel] = useState(false);
  const currentUser = useSelector((state) => state.user.currentUser);
  const [vehicle, setVehicle] = useState("");

  const handleClick = async () => {
    const url = `/inspection/${data.inspectionId}?download=1`;

    //download file from that url
    const response = await axios.get(url, {
      responseType: "blob",
    });

    const url2 = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url2;
    link.setAttribute("download", "inspection.pdf");
    document.body.appendChild(link);
    link.click();
  };

  const modal_handler = useCallback(
    (tyreReplacement, actionables) => {
      //   let firstActionable = actionables?.length > 0 ? actionables[0] : "REPLACEMENT";
      //   let secondActionable = actionables?.length > 1 ? actionables[1] : "---";
      //   let thirdActionable = actionables?.length > 2 ? actionables[2] : "---";
      // const replaced = {};
      //   data.map(({tyre:{prev, curr}})=>{
      //   const position = firstActionable=== "REPLACEMENT" && thirdActionable!== "REPLACEMENT" ? prev.position
      //   replaced[position] =  {...replaced[position], prev: prev.stencilNo};
      //   replaced[position] =  {...replaced[curr.position], curr: curr.stencilNo};

      // })

      setModalData(data?.tyreReplacement);
      setShowModal(true);
    },
    [showModal, modalData]
  );
  const modalHandler = useCallback(
    (data, actionables) => {
      if (data) {
        let replacedTyres = {};
        data.map(({ tyre: { prev, curr } }) => {
          // console.log({actionables, prev: {stencilNo: prev.stencilNo, position: prev.position}, curr: {stencilNo: curr.stencilNo, position: curr.position}})
          if (!replacedTyres[curr.position]) replacedTyres[curr.position] = {};
          if (!replacedTyres[prev.position]) replacedTyres[prev.position] = {};
          // replacedTyres[curr.position].curr = curr.stencilNo;
          let firstActionable =
            actionables?.length > 0 ? actionables[0] : "REPLACEMENT";
          let secondActionable =
            actionables?.length > 1 ? actionables[1] : "---";
          let thirdActionable =
            actionables?.length > 2 ? actionables[2] : "---";

          if (!actionables?.length) {
            replacedTyres[prev?.position].prev = prev.stencilNo;
            replacedTyres[prev?.position].curr = curr.stencilNo;
          } else {
            if (
              firstActionable === "REPLACEMENT" &&
              thirdActionable !== "REPLACEMENT"
            ) {
              // console.log("Here")
              replacedTyres[curr?.position].prev = prev.stencilNo;
              replacedTyres[curr.position].curr = curr.stencilNo;
            } else {
              // console.log("HREERE");
              replacedTyres[curr?.position].prev = prev.stencilNo;
              replacedTyres[curr.position].curr = curr.stencilNo;
            }
          }
          // console.log({replacedTyres})
        });
        Object.keys(replacedTyres)?.map((key) => {
          if (!replacedTyres[key] || !Object.keys(replacedTyres[key])?.length) {
            delete replacedTyres[key];
          }
        });
        setModalData(replacedTyres);
        setShowModal(true);
      } else {
        setShowModal(false);
        setModalData({});
      }
    },
    [showModal, modalData]
  );

  const fetchFile = async (url) => {
    const originalImage = url;
    const image = await fetch(originalImage);

    //Split image name
    const nameSplit = originalImage.split("/");
    const duplicateName = nameSplit.pop();

    const imageBlog = await image.blob();
    const imageURL = URL.createObjectURL(imageBlog);
    const link = document.createElement("a");
    link.href = imageURL;
    link.download = "" + duplicateName + "";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Fragment>
      {showModal && (
        <Modal
          handleClick={() => setShowModal(false)}
          title={"Vehicle Information: " + vehicle}
          className="max-w-2xl"
        >
          {/* <h1>This is the modal</h1> */}
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <TH scope="col">S.N.</TH>
                <TH scope="col">Tyre Position</TH>
                <TH scope="col">Previous Stencil</TH>
                <TH scope="col">Current Stencil</TH>
              </tr>
            </thead>
            <tbody>
              {Object.keys(modalData).map((key, index) => {
                {
                  /* console.log(modalData[key]) */
                }
                return (
                  <tr>
                    <TD>{index + 1}</TD>
                    <TD>{key}</TD>
                    <TD>{modalData[key]?.prev}</TD>
                    <TD>{modalData[key]?.curr}</TD>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Modal>
      )}
      <tr className={`${idx % 2 !== 0 && "bg-gray-100"}`}>
        <TD>{(parseInt(page) - 1) * 20 + (idx + 1)}</TD>
        <TD>{data?.inspectionDate}</TD>
        <TD>{data?.vehicle?.registrationNumber}</TD>
        <TD>{data?.inspectedHub}</TD>
        <TD>{data?.inspectedBy ? data?.inspectedBy : "NA"}</TD>
        <TD>
          {data.inspectionContractType
            ? data.inspectionContractType
            : data?.contractType
            ? data?.contractType
            : "NA"}
        </TD>
        <TD
          className={`${
             data.odometerChanged
              ? "text-green-600"
              : !data.odometerStatus
              ? "text-red-600"
              : ""
          }`}
        >
          {/* {data?.odometerStatus ? "" : "~"} */}
          {data?.killometerTravelled}
        </TD>
        <TD
          className={`${
            data.odometerChanged
              ? "text-green-600"
              : !data.odometerStatus
              ? "text-red-600"
              : ""
          }`}
        >
          {data?.odometerReading}
        </TD>
        <TD>{data?.wheelAlignment ? "Yes" : "No"}</TD>
        <TD
          className={
            data?.wheelAlignment?.file
              ? "hover:text-green-500 cursor-pointer"
              : ""
          }
          onClick={
            data?.wheelAlignment?.file
              ? () => fetchFile(data.wheelAlignment.file)
              : null
          }
        >
          {data?.wheelAlignment?.file ? "Yes" : "No"}
        </TD>
        <TD
        // className={
        //   data?.rotation ? "hover:text-green-500 cursor-pointer" : ""
        // }
        // onClick={
        //   data?.rotation ? () => modalHandler(data.tyreRotation) : null
        // }
        >
          {data?.rotation ? "Yes" : "No"}
        </TD>
        <TD
          className={
            data?.replacement ? "hover:text-green-500 cursor-pointer" : ""
          }
          onClick={
            data?.replacement
              ? () => {
                  setVehicle(data.vehicle?.registrationNumber);
                  modal_handler(data.tyreReplacement, data.actionables);
                }
              : null
          }
        >
          {Object.keys(data?.tyreReplacement)?.length ?? 0}
        </TD>
        <TD>{data?.inspectionType ? data.inspectionType?.replace(/^./, c => c.toUpperCase()) : ''}</TD>
        <TD>
          <BiCloudDownload
            className="w-8 h-8 text-green-500 hover:scale-105 cursor-pointer"
            onClick={handleClick}
          />
        </TD>
        <TD>
          {currentUser &&
          currentUser.userRole &&
          checkPermission(
            [permissions.inspection_kilometer_update],
            currentUser
          ) ? (
            <div className="">
              <button
                onClick={() => setShowEditModel(true)}
                className="p-2 m-1  rounded-md bg-green-500 hover:bg-green-600 text-white"
              >
                <FaEdit />
              </button>
            </div>
          ) : (
            <p>----</p>
          )}
        </TD>
      </tr>
      {showEditModel && (
        <EditInspection
          data={data}
          handleClick={() => setShowEditModel(false)}
          getData={getData}
          prevOdometerReading={prevInspection?.odometerReading ?? 0}
        />
      )}
    </Fragment>
  );
};

const EditInspection = ({
  handleClick,
  data,
  prevOdometerReading,
  getData,
}) => {
  const [disabled, setIsDisabled] = useState(false);
  const [hasErrors, setHasErrors] = useState(false);
  const [killometerTravelled, setKillometerTravelled] = useState(
    data.killometerTravelled
  );
  let errors = {};

  const queryClient = useQueryClient();
  const formik = useFormik({
    initialValues: {
      odometerReading: data.odometerReading,
      odometerChanged: data.odometerChanged,
      newOdometerStartReading: data.newOdometerStartReading,
      oldOdometerEndReading: data.oldOdometerEndReading
        ? data.oldOdometerEndReading
        : prevOdometerReading
        ? prevOdometerReading
        : 0,
      killometerTravelled: killometerTravelled,
      odometerStatus: data.odometerStatus,
    },
    onSubmit: async (values) => {
      try {
        setIsDisabled(true);
        const Data = await updateDocumentByID("inspection", data.inspectionId, {
          ...values,
          ...(!formik.values.odometerStatus && {
            odometerReading: data.odometerReading,
          }),
        });
        if (Data) {
          toast.success("Successfully Updated");
          queryClient.invalidateQueries("inspection");
          handleClick();
        }
        setIsDisabled(false);
        getData();
      } catch (error) {
        setIsDisabled(false);
        return null;
      }
    },

    validate: (values) => {
      let err = false;
      if (!values.killometerTravelled) {
        errors.killometerTravelled = "Required";
        err = true;
      }
      if (values.killometerTravelled < 0) {
        if (formik.values.odometerStatus)
          errors.killometerTravelled =
            "Odometer Reading should be greater than previous value";
        else errors.killometerTravelled = "Please enter a Positive value";
        err = true;
      }
      setHasErrors(err);
      return errors;
    },
  });

  return (
    <Modal
      handleClick={handleClick}
      title={`${disabled ? "View" : "Edit"} Inspection`}
      className="max-w-2xl"
    >
      <FormikProvider value={formik}>
        <Form className="px-5 text-gray-700 text-base grid  lg:gap-x-14 gap-y-5 w-full">
          {
            <div className="block mt-2  ">
              {/* Odometer Status
            <br /> */}
              <label for="odometerStatus">
                <input
                  type="checkbox"
                  id="odometerStatus"
                  name="odometerStatus"
                  checked={!formik.values.odometerStatus}
                  disabled={formik.values.odometerChanged}
                  onChange={() => {
                    if (formik.values.odometerStatus === false) {
                      formik.setFieldValue("killometerTravelled", 0);
                      setKillometerTravelled(0);
                    }
                    formik.setFieldValue(
                      "odometerStatus",
                      !formik.values.odometerStatus
                    );
                  }}
                />{" "}
                Odometer is not working Correctly
              </label>
              {/* <br /> */}
            </div>
          }

          {
            <div className="block">
              {/* Odometer Changed */}
              {/* <br /> */}
              <label for="odometerChanged">
                <input
                  type="checkbox"
                  id="odometerChanged"
                  name="odometerChanged"
                  checked={formik.values.odometerChanged}
                  disabled={
                    !formik.values.odometerStatus &&
                    !formik.values.odometerChanged
                  }
                  onChange={() => {
                    if (formik.values.odometerChanged === false) {
                      formik.setFieldValue("killometerTravelled", 0);
                      setKillometerTravelled(0);
                    }
                    formik.setFieldValue(
                      "odometerChanged",
                      !formik.values.odometerChanged
                    );
                  }}
                />{" "}
                Odometer Has Changed
              </label>
              <br />
            </div>
          }

          {formik.values.odometerChanged ? (
            <div className="block">
              <InputField
                desable={disabled}
                onChange={(e) => {
                  // console.log(
                  //   e.target.value,
                  //   prevOdometerReading,
                  //   formik.values.odometerChanged,
                  //   formik.values.newOdometerStartReading
                  // );
                  if (formik.values.odometerChanged)
                    formik.setFieldValue(
                      "killometerTravelled",
                      (e.target.value - prevOdometerReading ?? 0) +
                        (formik.values.odometerReading -
                          formik.values.newOdometerStartReading)
                    );
                  formik.setFieldValue("oldOdometerEndReading", e.target.value);
                }}
                type="number"
                label="Old Odometer End Reading"
                name="oldOdometerEndReading"
              />
              {formik.touched.oldOdometerEndReading &&
              formik.errors.oldOdometerEndReading ? (
                <p className="text-red-500 font-normal">
                  *{formik.errors.oldOdometerEndReading}
                </p>
              ) : null}
            </div>
          ) : (
            <></>
          )}

          {formik.values.odometerChanged ? (
            <div className="block">
              <InputField
                desable={disabled}
                onChange={(e) => {
                  // console.log(
                  //   e.target.value,
                  //   prevOdometerReading,
                  //   formik.values.odometerChanged,
                  //   formik.values.newOdometerStartReading
                  // );
                  if (formik.values.odometerChanged)
                    formik.setFieldValue(
                      "killometerTravelled",
                      (formik.values.oldOdometerEndReading -
                        prevOdometerReading ?? 0) +
                        (formik.values.odometerReading - e.target.value)
                    );
                  formik.setFieldValue(
                    "newOdometerStartReading",
                    e.target.value
                  );
                }}
                type="number"
                label="New Odometer Start Reading"
                name="newOdometerStartReading"
              />

              {formik.touched.newOdometerStartReading &&
              formik.errors.newOdometerStartReading ? (
                <p className="text-red-500 font-normal">
                  *{formik.errors.newOdometerStartReading}
                </p>
              ) : null}
            </div>
          ) : (
            <></>
          )}

          {formik.values.odometerStatus || formik.values.odometerChanged ? (
            <div className="block w-full">
              <InputField
                desable={disabled}
                onChange={(e) => {
                  formik.setFieldValue("odometerReading", e.target.value);
                  // console.log(prevOdometerReading);
                  // console.log(e.target.value, prevOdometerReading, formik.values.odometerChanged, formik.values.newOdometerStartReading)
                  if (formik.values.odometerChanged)
                    formik.setFieldValue(
                      "killometerTravelled",
                      (formik.values.oldOdometerEndReading -
                        prevOdometerReading ?? 0) +
                        (e.target.value - formik.values.newOdometerStartReading)
                    );
                  else if (formik.values.odometerStatus)
                    formik.setFieldValue(
                      "killometerTravelled",
                      prevOdometerReading
                        ? e.target.value - prevOdometerReading
                        : killometerTravelled +
                            (e.target.value - data.odometerReading)
                    );
                }}
                type="number"
                label="Odometer Reading"
                name="odometerReading"
              />

              {formik.touched.odometerReading &&
              formik.errors.odometerReading ? (
                <p className="text-red-500 font-normal">
                  *{formik.errors.odometerReading}
                </p>
              ) : null}
            </div>
          ) : (
            <></>
          )}

          <div className="block w-full">
            <InputField
              desable={data.odometerChanged || formik.values.odometerStatus}
              type="number"
              label="Kilometer Travelled"
              name="killometerTravelled"
            />

            {formik.touched.killometerTravelled &&
            formik.errors.killometerTravelled ? (
              <p className="text-red-500 font-normal">
                *{formik.errors.killometerTravelled}
              </p>
            ) : null}
          </div>
        </Form>
        <div className="px-5 flex justify-end items-center gap-4 pb-8 flex-wrap sm:w-full mt-2">
          <Button
            type="button"
            // bgPrimary
            disabled={hasErrors}
            className={`${
              hasErrors || disabled
            } ? 'bg-gray-400': 'bg-green-500`}
            onClick={formik.handleSubmit}
          >
            {disabled ? "Saving Changes..." : "Save Changes"}
          </Button>
        </div>
      </FormikProvider>
    </Modal>
  );
};
